import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Layout from '@components/common/Layout';
import SatInput from '@components/common/satUI/SatInput';
import SatDataGridNew from '@components/common/satUI/SatDataGrid';

const AgentListEdit  = props => {

    const dispatch = useDispatch();

    const {
        agentColumns,
        agentList,
        visible
    } = props;    
 
    return (visible && (
        <div className="table-wrap">
            <SatDataGridNew
                columns={agentColumns}
                dataSource={agentList}
                noDataRender={'검색결과가 없습니다.'}
            />
        </div>
        )
    );
};

export default AgentListEdit;